<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/usuario', query: $route.query }"> Usuário </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <div style="position: relative; width: 40%; left: 60%">
        <avatar ref="avatar" :title="title" :isAllowed="!readOnly" />
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <formulario
          ref="formulario"
          :perfis="filteredPerfil"
          :departamentos="departamentos"
          :cargos="filteredCargo"
          :unidadesAdm="filteredUndAdm"
          :permissoes="filteredPermissoes"
          :isAllowed="readOnly"
        />
      </v-form>
      <v-row align="center">
        <v-col cols="12" sm="2">
          <v-checkbox v-model="usuario.ativo" :readonly="readOnly" label="Ativo"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3">
          <v-checkbox v-model="resetSenha" label="Resetar senha?" v-if="!readOnly"></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn :to="{ path: '/usuario', query: $route.query }" color="error" class="mr-4" v-if="!readOnly"> Voltar </v-btn>
          <v-btn :to="{ path: '/usuario', query: $route.query }" color="success" class="mr-4" v-else> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarUsuarioAsync } from "../../../services/usuarioService";
import { mapState } from "vuex";
import Formulario from "./Formulario";
import Avatar from "../../Avatar/AvatarCard";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";
import { getUserPermission } from "@/services/loginService";


export default {
  name: "editarUsuario",
  data: () => ({
    overlay: false,
    valid: true,
    title: "Foto de Perfil",
    resetSenha: false,
    readOnly: false,
  }),
  computed: {
    ...mapState("usuario", ["usuario"]),
    ...mapState("departamento", ["departamentos"]),
    ...mapState("cargo", ["cargos"]),
    ...mapState("perfil", ["perfis"]),
    ...mapState("local", ["locais"]),
    ...mapState("permissao", ["permissoes"]),

    filteredCargo() {
      return this.cargos.filter((c) => {
        return c.ativo === true;
      });
    },
    filteredPerfil() {
      return this.perfis.filter((p) => {
        return p.ativo === true;
      });
    },
    filteredUndAdm() {
      const tipos = [2, 3];
      return this.locais.filter((u) => {
        return (u.ativo === true && tipos.includes(u.idTipoLocais));
      });
    },
    filteredPermissoes() {
      return this.permissoes.filter((p) => {
        return p.ativo === true;
      });
    },
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        var img = this.$refs.avatar.getImg();
        const resposta = await editarUsuarioAsync(
          this.usuario.id,
          this.$refs.formulario.nome,
          this.$refs.formulario.email,
          this.usuario.ativo,
          this.$refs.formulario.telefone,
          this.$refs.formulario.matricula,
          this.$refs.formulario.cargoSelected.id,
          this.$refs.formulario.perfilSelected.id,
          this.$refs.formulario.unidadeAdmSelected.map((a) => a.id),
          this.$refs.formulario.usuarioDepartamentosPayload,
          //this.$refs.formulario.departamentoSelected.map((a) => a.id),
          img,
          this.resetSenha
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          /*this.$fire({
            text: "Usuário editado com sucesso",
            type: "success",
            timer: 3000,
          });*/
          this.overlay = false;
          this.$router.push({ path: '/usuario', query: this.$route.query });
        }
      }
    },
  },
  mounted() {
    this.readOnly = !getUserPermission(1);
    this.$refs.formulario.fillForm(this.usuario);
    if (this.usuario.avatar) {
      this.$refs.avatar.setImg(this.usuario.avatar);
    }
  },
  components: {
    Formulario,
    Avatar,
    TabNavegacao,
  },
};
</script>
